<template>
  <div class="content-flip">
  <div class="flip-container">
    <div
      class="flip-text"
      :style="{
        transform: `rotateX(${rotation}deg)`,
        opacity: opacity,
        transition: transitionStyle,
      }"
    >
      {{ $t(currentWordKey) }}
    </div>
  </div>
  <img id="logo-presentation" src="../../assets/logo.svg">
  </div>
</template>

<script>
export default {
  name: "FlippingWords",
  data() {
    return {
      // Keys for the words, which will point to translation strings
      wordKeys: [
        "flippingWords.collaboration",
        "flippingWords.adaptability",
        "flippingWords.socialResponsibility",
        "flippingWords.innovation",
        "flippingWords.integrity",
        "flippingWords.excellence",
        "flippingWords.clientCentricity"
      ],
      currentIndex: 0,
      rotation: 0,
      opacity: 1,
      transitionStyle: "transform 1.5s ease, opacity 1s ease",
      isFlipping: false,
      intervalId: null // To store the interval ID for cleanup
    };
  },
  computed: {
    currentWordKey() {
      return this.wordKeys[this.currentIndex];
    }
  },
  mounted() {
    this.startFlipping();
  },
  beforeUnmount() {
    // Clear the interval when the component is destroyed to prevent memory leaks
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    startFlipping() {
      // Clear any existing interval to prevent duplicates if mounted multiple times
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      this.intervalId = setInterval(() => {
        this.isFlipping = true;

        // Step 1: Start rotating out (flip upward) and prepare to fade out
        this.rotation = 90;
        this.opacity = 1; // Ensure it's visible before starting rotation

        // Step 2: After the first part of rotation, start fading out
        // This setTimeout duration (0.5s) should be less than the rotation transition (1.5s)
        // to make the fade-out start while the word is still flipping away.
        setTimeout(() => {
          this.opacity = 0; // Fade out the current word

          // Step 3: Once faded out, change the word and reset its state for the next flip-in
          // This setTimeout duration (1s) should match the opacity transition.
          setTimeout(() => {
            this.currentIndex = (this.currentIndex + 1) % this.wordKeys.length;

            // Reset state for the new word before it flips in
            this.transitionStyle = "none"; // Disable transition for instant reset
            this.rotation = -90; // Prepare for flip in from bottom
            this.opacity = 0; // Keep hidden until ready to flip in

            // Step 4: Re-enable transition and flip the new word in
            this.$nextTick(() => {
              // A small delay (e.g., 50ms) ensures the browser applies `transitionStyle: "none"`
              // before re-enabling it for the next animation.
              setTimeout(() => {
                this.transitionStyle = "transform 1.5s ease, opacity 1s ease";
                this.rotation = 0; // Rotate from -90° back to 0°
                this.opacity = 1; // Fade in the new word
              }, 50);
            });
          }, 1000); // Duration for fading out (opacity 0)
        }, 500); // Start fade-out 0.5s into the rotation
      }, 3000); // Total cycle time for each word: 3 seconds (adjust if needed)
    }
  }
};
</script>

<style scoped>
/* Base styles (for desktop and large screens) */
.content-flip {
  height: 100vh;
  margin-bottom: 30vh;
}
.flip-container {
  perspective: 1000px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding-top: 250px;
  margin-bottom: 10vh;
 
}

.flip-text {
  font-size: 98px;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  font-weight: 600;
  color: #5762799f;
  
}

#logo-presentation {
  
  max-width: 220px;
  height: auto;
  display: block;
  margin: 0 auto;
  transform: translateY(-70px);
  padding-top: 20px;
}

/* --- Responsive Adjustments --- */

/* For Tablet and smaller desktops (max-width: 1200px) */
@media (max-width: 1300px) {
  .content-flip {
    margin-bottom: 30vh;
    margin-top:10vh;
  } 
  .flip-container {
    height: 120px;
    padding-top: 180px;
  }

  .flip-text {
    font-size: 7vw;
  }

  #logo-presentation {
    padding-top: 40px;
  }
}

@media (max-width: 1000px) {
  .flip-container {
    height: 70px;
    padding-top: 120px;
  }

  .flip-text {
    font-size: 5vw;
  }

  #logo-presentation {
    padding-top: 20px;
  }
}

/* For Tablets (max-width: 768px) */
@media (max-width: 768px) {
.content-flip {
    margin-bottom: 30vh;
    margin-top:20vh;
  }

  .flip-container {
    height: 70px;
    padding-top: 120px;
  }

  .flip-text {
    font-size: 6vw;
  }

  #logo-presentation {
    padding-top: 10px;
    width: 25%; /* Reduced logo size on mobile */
  }
}

/* For Mobile (max-width: 480px) */
@media (max-width: 500px) {
  .content-flip {
    margin-bottom: 30vh;
    margin-top:20vh;
  }
  .flip-container {
    height: 120px;
    padding-top: 80px;
  }

  .flip-text {
    font-size: 40px;
    text-align: center;
  }

  #logo-presentation {
    padding-top: 20px;
    width: 40%; /* Reduced logo size on mobile */
  }
}

/* Fallback/Correction for min-font-size */
@media (max-width: 600px) {
.content-flip {
    margin-bottom: 30vh;
    margin-top:20vh;
  }

  .flip-container{
    height: 100px;
    
  }
  .flip-text {
    font-size: 40px;
    text-align: center;
  }
  #logo-presentation {
    padding-top: 20px;
    width: 30%; /* Reduced logo size on mobile */
  }
}


@media (max-width: 400px) {
  .content-flip {
    margin-bottom: 30vh;
    margin-top:20vh;
  }
  .flip-container{
    height: 100px;
    
  }
  .flip-text {
    font-size: 32px;
    text-align: center;
  }
  #logo-presentation {
    padding-top: 0px;
    width: 35%; /* Reduced logo size on mobile */
  }
}
</style>